/*
 * @Author: error: git config user.name && git config user.email & please set dead value or install git
 * @Date: 2022-12-06 14:06:13
 * @LastEditors: error: git config user.name && git config user.email & please set dead value or install git
 * @LastEditTime: 2022-12-07 10:01:53
 * @FilePath: \ioc_base\src\modules\personAuthorization\config\groupTable.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import i18n from "@src/common/lib/i18n";
import utils from "@src/common/utils";
import { Dic } from "$utils";
export const groupTable = function (isSelect=false) {
  return {
    add: "新增",
    edit: "修改",
    view: "查看",
    page: true,
    selection: isSelect,
    index: true,
    indexLabel: "序号",
    refreshBtn: false,
    columnBtn: false,
    stripe: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    viewFormSlot: true,
    labelSuffix: "：",
    size: "small",
    maxHeight: "100%",
    labelWidth: "120px",
    menuAlign: "center",
    labelPosition: "right",
    searchMenuSpan: 6,
    searchBtn: false,
    dialogHeight: 200,
    dialogWidth: "400px",
    viewDialogWidth: "700px",
    viewDialogHeight: 450,
    emptyText: i18n.t("personAccess.title.noData"),
    menu: false,
    highlightCurrentRow: true,
    column: [
      {
        label: "权限组名称",
        prop: "thirdRightGroupName",
      }
    ]
  };
};
